import { CheckCircle, Zap, BarChart, Shield, Globe, Coins } from "lucide-react";

const ComapnyBenifitsSection = () => {
  const benefits = [
    {
      title: " Secure Payments",
      description: (
        <>
          All payments are managed via <b>regulated PSPs (PayPal, Binance Pay)</b> with escrow protection. Freelancers can choose payouts in fiat, stablecoins, or DGK Token.
        </>
      ),
      icon: <Shield className="w-12 h-12 text-emerald-500" />,
    },
    {
      title: "DGK Utility Rewards",
      description:(
        <>Use DGK to enjoy <b>lower fees (as low as 1%)</b>, loyalty rewards, and boosted visibility on the platform.</>
      ),
      icon: <Coins className="w-12 h-12 text-emerald-500" />,
    },
    {
      title: "Verified Reputation",
      description:(
        <>Build a transparent reputation profile with <b>reviews, ratings, and AI-powered scoring</b> based on completed projects.</>
      ),
      icon: <BarChart className="w-12 h-12 text-purple-500" />,
    },
    {
      title: "Fast & Flexible",
      description: (
        <> Funds are released quickly after project validation, with the option of <b>instant DGK payouts</b> once PSP settlement is complete.</>
      ),
      icon: <Zap className="w-12 h-12 text-amber-500" />,
    },
    {
      title: "Quality Assurance",
      description: (
        <> All freelancers and companies are <b> verified and reviewed </b> to ensure trust and professional quality.</>
      ),
      icon: <CheckCircle className="w-12 h-12 text-green-500" />,
    },
    {
      title: "Global Opportunities",
      description: (
        <>Connect with <b> clients in 120+ countries </b> and access high-value projects across industries worldwide.</>
      ),
      icon: <Globe className="w-12 h-12 text-sky-500" />,
    },
  ];

  return (
    <section className="container mx-auto px-4 py-24 relative">
      {/* Enhanced layered backgrounds */}
      <div className="absolute inset-0 bg-gradient-to-b from-white via-emerald-50/20 to-white" />
      <div className="absolute inset-0 grid grid-pattern opacity-[0.03]" />

      <div className="relative">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Benefits of the DGK Freelance Hub
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Discover why thousands of professionals choose our platform
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 xl:gap-12">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="p-8 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 flex flex-col items-center text-center transform hover:-translate-y-1"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="p-4 rounded-full bg-gray-50 mb-6">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">
                {benefit.title}
              </h3>
              <p className="text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>

   <div className="mt-16 flex justify-center">
  <div className="max-w-4xl bg-gradient-to-r from-sky-50 to-emerald-50 rounded-2xl p-8 shadow-md border border-sky-100">
    <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
      Why Choose Digika.ai?
    </h3>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      {[
        {
          title: "Lower Fees",
          description: (
            <>Pay only <span className="font-bold">1% when using DGK payouts</span> (vs. 10–20% on traditional platforms).</>
          ),
        },
        {
          title: "Compliance-First Escrow",
          description: (
            <>Payments secured through <span className="font-bold">regulated PSPs (PayPal, Binance Pay)</span>.</>
          ),
        },
        {
          title: "Skill Verification",
          description: "Freelancers are vetted and reviewed to guarantee quality.",
        },
        {
          title: "24/7 Global Support",
          description: "Always-on assistance for clients and freelancers worldwide.",
        },
        {
          title: "Multi-Currency Support",
          description: (
            <>Get paid in <span className="font-bold">fiat, stablecoins, or DGK Token</span>.</>
          ),
        },
        {
          title: "Dispute Resolution",
          description: "Mediation by Digika + PSP frameworks + liability insurance.",
        },
        {
          title: "AI Matching",
          description: "Advanced AI connects you to the right projects faster.",
        },
        {
          title: "Continuous Platform Upgrades",
          description: "Regular improvements with new features, SDKs, and tools.",
        },
      ].map((feature, index) => (
        <div key={index} className="flex items-start gap-3">
          <CheckCircle className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-1" />
          <div>
            <span className="font-semibold text-gray-900">{feature.title}</span>
            <p className="text-gray-700">{feature.description}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>


      </div>
    </section>
  );
};

export default ComapnyBenifitsSection;
